/* global window */
import axios from 'axios';

import AuthenticationService from '../services/userService';

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    const res = err.response;
    if (
      typeof res !== 'undefined' &&
      typeof res.status !== 'undefined' &&
      res.status === 401 &&
      res.config &&
      !res.config.__isRetryRequest
    ) {
      AuthenticationService.logout().then(() => {
        window.location = '/login';
      });
    }
    return Promise.reject(err);
  }
);



// WEBPACK FOOTER //
// ./src/utilities/http.interceptor.js